export enum SeriesLabelIcon {
	DASH,
	CIRCLE
}
